/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA
 *
 */

/**
 * Re rank headings based inside the given element
 * @param {HTMLElement} element - the container
 * @param {number} [reRankBelow=2] - re-rank only if there are headings level below
 */
export function reRankHeadings(element, reRankBelow = 2) {
    const maxLevel = 6;
    if (element instanceof HTMLElement) {
        for (let level = 1; level <= maxLevel; level++) {
            const headings = element.querySelectorAll(`h${level}`);
            const reRank = headings.length;
            if (reRank) {
                for (let heading of headings) {
                    heading.setAttribute('aria-level', level + 1);
                }
            }
            if (!reRank && level >= reRankBelow) {
                break;
            }
        }
    }
}
